

export class ChangePasswordDto implements IChangePasswordDto {
    id!: number | undefined;
    currentPassword!: string | undefined;
    password!: string | undefined;

    constructor(data?: IChangePasswordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.currentPassword = _data["currentPassword"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): ChangePasswordDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangePasswordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["currentPassword"] = this.currentPassword;
        data["password"] = this.password;
        return data; 
    }
}

export interface IChangePasswordDto {
    id: number | undefined;
    currentPassword: string | undefined;
    password: string | undefined;
}

